import { LayoutFeatureArea, StepLayoutFeatureArea } from '@paragon/contract-library';
import { Polygon2D, Polygon3D } from '@paragon/geometry-library';
import { SlopedBox } from '@paragon/layout';

export function calculateLayoutFeatureArea2DShape(feature: Omit<LayoutFeatureArea, 'guid'>): Polygon2D | null {
  return (
    SlopedBox.fromDescription({
      ...feature.area,
      bottomElevation: 0,
      topElevation: 1,
      sideAngle: 90,
    })?.bottomFace?.projectTo2D() ?? null
  );
}

export function calculateStepArea3DShape(
  step: Omit<StepLayoutFeatureArea, 'guid'>,
  bottomElevation: number,
): Polygon3D[] {
  return (
    SlopedBox.fromDescription({
      ...step.area,
      bottomElevation,
      topElevation: bottomElevation + step.height,
      sideAngle: 90,
    })?.facesExcludingBottom ?? []
  );
}
